// This file was automatically generated from appshared.drugIntxns.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.drugIntxns');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.drugIntxns.alertsShell = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="drug-allergy-alert"></div><div class="drug-drug-alert"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.drugIntxns.drugDrugError = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8NotificationCaution alertWrap"><p>***Drug-to-drug decision support not available.</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.drugIntxns.drugAllergyError = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8NotificationCaution alertWrap"><p>***Drug-to-allergy decision support not available.</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.drugIntxns.drugDrugResultSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.count_total > 0) {
    if (opt_data.major_severity_interactions.length > 0) {
      output.append('<div class="major-drug-drug-interactions el8NotificationStop alertWrap"><h3 class="el8NotificationStopHeader">!! Major Drug-to-Drug Interaction !!</h3><p><span class="alert-text">', soy.$$escapeHtml(opt_data.selected_medication_name), ' severely interacts with ');
      var intxList9161 = opt_data.major_severity_interactions;
      var intxListLen9161 = intxList9161.length;
      for (var intxIndex9161 = 0; intxIndex9161 < intxListLen9161; intxIndex9161++) {
        var intxData9161 = intxList9161[intxIndex9161];
        var drugList9162 = intxData9161.drugs;
        var drugListLen9162 = drugList9162.length;
        for (var drugIndex9162 = 0; drugIndex9162 < drugListLen9162; drugIndex9162++) {
          var drugData9162 = drugList9162[drugIndex9162];
          output.append(soy.$$escapeHtml(drugData9162), (drugIndex9162 == drugListLen9162 - 1) ? '. ' : ', ');
        }
      }
      output.append('</span> <a class="drug-drug-interaction-detail" _section="major">view details</a></p></div>');
    }
    if (opt_data.moderate_severity_interactions.length > 0) {
      output.append('<div class="moderate-drug-drug-interactions el8NotificationAlert alertWrap"><h3 class="el8NotificationAlertHeader">Moderate Interaction</h3><p><span class="alert-text">', soy.$$escapeHtml(opt_data.selected_medication_name), ' has moderate interactions with ');
      var intxList9177 = opt_data.moderate_severity_interactions;
      var intxListLen9177 = intxList9177.length;
      for (var intxIndex9177 = 0; intxIndex9177 < intxListLen9177; intxIndex9177++) {
        var intxData9177 = intxList9177[intxIndex9177];
        var drugList9178 = intxData9177.drugs;
        var drugListLen9178 = drugList9178.length;
        for (var drugIndex9178 = 0; drugIndex9178 < drugListLen9178; drugIndex9178++) {
          var drugData9178 = drugList9178[drugIndex9178];
          output.append(soy.$$escapeHtml(drugData9178), (drugIndex9178 == drugListLen9178 - 1) ? '. ' : ', ');
        }
      }
      output.append('</span> <a class="drug-drug-interaction-detail" _section="moderate">view details</a></p></div>');
    }
    if (opt_data.minor_severity_interactions.length > 0) {
      output.append('<div class="minor-drug-drug-interactions el8NotificationCaution alertWrap"><p><span class="alert-text">', soy.$$escapeHtml(opt_data.selected_medication_name), ' has minor interactions with ');
      var intxList9193 = opt_data.minor_severity_interactions;
      var intxListLen9193 = intxList9193.length;
      for (var intxIndex9193 = 0; intxIndex9193 < intxListLen9193; intxIndex9193++) {
        var intxData9193 = intxList9193[intxIndex9193];
        var drugList9194 = intxData9193.drugs;
        var drugListLen9194 = drugList9194.length;
        for (var drugIndex9194 = 0; drugIndex9194 < drugListLen9194; drugIndex9194++) {
          var drugData9194 = drugList9194[drugIndex9194];
          output.append(soy.$$escapeHtml(drugData9194), (drugIndex9194 == drugListLen9194 - 1) ? '. ' : ', ');
        }
      }
      output.append('</span> <a class="drug-drug-interaction-detail" _section="minor">view details</a></p></div>');
    }
    if (opt_data.unknown_severity_interactions.length > 0) {
      output.append('<div class="unknown-drug-drug-interactions el8NotificationCaution alertWrap"><p><span class="alert-text">', soy.$$escapeHtml(opt_data.selected_medication_name), ' interacts with ');
      var intxList9209 = opt_data.unknown_severity_interactions;
      var intxListLen9209 = intxList9209.length;
      for (var intxIndex9209 = 0; intxIndex9209 < intxListLen9209; intxIndex9209++) {
        var intxData9209 = intxList9209[intxIndex9209];
        var drugList9210 = intxData9209.drugs;
        var drugListLen9210 = drugList9210.length;
        for (var drugIndex9210 = 0; drugIndex9210 < drugListLen9210; drugIndex9210++) {
          var drugData9210 = drugList9210[drugIndex9210];
          output.append(soy.$$escapeHtml(drugData9210), (drugIndex9210 == drugListLen9210 - 1) ? '. ' : ', ');
        }
      }
      output.append('</span> <a class="drug-drug-interaction-detail" _section="unknown">view details</a></p></div>');
    }
  }
  output.append((opt_data.unknown_medications.length) ? '<div class="el8NotificationAlert alertWrap"><p><span class="el8Bold el8LargeFontSize">Drug Interaction Warnings incomplete</span> because of user created meds. Please change to Elation Health database meds. <a class="drug-drug-unknown-detail">View user created meds involved</a></p></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.drugIntxns.drugDrugIntxnDetail = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer">', (opt_data.severity_level == 'Major') ? '<div class="el8NotificationStop"><h3 class="el8NotificationStopHeader">!! Major Drug-to-Drug Interaction !!</h3></div>' : (opt_data.severity_level == 'Moderate') ? '<h3 class="el8NotificationAlertHeader">Moderate Drug-to-Drug Interaction</h3>' : (opt_data.severity_level == 'Minor') ? '<h3 class="el8NotificationAlertHeader">Minor Drug-to-Drug Interaction</h3>' : '<h3 class="el8NotificationAlertHeader">Alert</h3>', '<p class="el8LargeFontSize el8Bold padb10">', (opt_data.severity_level == 'Major') ? soy.$$escapeHtml(opt_data.selected_medication_name) + ' severely interacts with ' : (opt_data.severity_level == 'Moderate') ? soy.$$escapeHtml(opt_data.selected_medication_name) + ' has moderate interactions with ' : (opt_data.severity_level == 'Minor') ? soy.$$escapeHtml(opt_data.selected_medication_name) + ' has minor interactions with ' : soy.$$escapeHtml(opt_data.selected_medication_name) + ' interacts with ');
  var intxList9248 = opt_data.interactions;
  var intxListLen9248 = intxList9248.length;
  for (var intxIndex9248 = 0; intxIndex9248 < intxListLen9248; intxIndex9248++) {
    var intxData9248 = intxList9248[intxIndex9248];
    var drugList9249 = intxData9248.drugs;
    var drugListLen9249 = drugList9249.length;
    for (var drugIndex9249 = 0; drugIndex9249 < drugListLen9249; drugIndex9249++) {
      var drugData9249 = drugList9249[drugIndex9249];
      output.append(soy.$$escapeHtml(drugData9249), (drugIndex9249 == drugListLen9249 - 1) ? '. ' : ', ');
    }
  }
  output.append('</p>');
  var intxList9259 = opt_data.interactions;
  var intxListLen9259 = intxList9259.length;
  for (var intxIndex9259 = 0; intxIndex9259 < intxListLen9259; intxIndex9259++) {
    var intxData9259 = intxList9259[intxIndex9259];
    output.append('<p class="padv10 el8BlackText">', soy.$$escapeHtml(intxData9259.message), ' ');
    if (intxData9259.professional_monograph) {
      output.append('<a class="monograph-show-hide" _mid="', soy.$$escapeHtml(intxIndex9259), '" href="">View Monograph</a>');
      el8.template.appshared.drugIntxns.drugDrugMonograph({monograph: intxData9259.professional_monograph, monographId: intxIndex9259}, output);
    }
    output.append('</p>');
  }
  output.append('<div class="padb50"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.drugIntxns.drugDrugMonograph = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Hidden el8SettingsBackground mt10 mb20" id="monograph-', soy.$$escapeHtml(opt_data.monographId), '"><div class="padh20"><p class="el8AlignRight el8SystemText padt10 padb20">Clinical Monograph from Wolters Kluwer Health</p><h4 class="el8ParagraphHeader padb10">', soy.$$escapeHtml(opt_data.monograph.title), '</h4><div class="el8FieldSection clearfix w100"><div class="el8Col4"><p class="el8NormalLabel el8GrayText">Management Level:</p></div><div class="el8Col8"><p>', soy.$$escapeHtml(opt_data.monograph.managementlevel), '</p></div></div><div class="el8FieldSection clearfix w100"><div class="el8Col4"><p class="el8NormalLabel el8GrayText">Documentation Level:</p></div><div class="el8Col8"><p>', soy.$$escapeHtml(opt_data.monograph.documentationlevel), '</p></div></div><div class="el8FieldSection clearfix w100 padt10"><div class="el8Col4"><p class="el8NormalLabel el8GrayText">Severity Level:</p></div><div class="el8Col8"><p>', soy.$$escapeHtml(opt_data.monograph.severitylevel), '</p></div></div><div class="el8FieldSection clearfix w100"><div class="el8Col4"><p class="el8NormalLabel el8GrayText">Onset:</p></div><div class="el8Col8"><p>', soy.$$escapeHtml(opt_data.monograph.onset), '</p></div></div><p class="el8Bold padt20 padb5">Alert</p>');
  var alertList9288 = opt_data.monograph.alert;
  var alertListLen9288 = alertList9288.length;
  for (var alertIndex9288 = 0; alertIndex9288 < alertListLen9288; alertIndex9288++) {
    var alertData9288 = alertList9288[alertIndex9288];
    output.append('<p class="padb20">', soy.$$escapeHtml(alertData9288), '</p>');
  }
  output.append('<p class="el8Bold padb5">Effect</p>');
  var effectList9294 = opt_data.monograph.effect;
  var effectListLen9294 = effectList9294.length;
  for (var effectIndex9294 = 0; effectIndex9294 < effectListLen9294; effectIndex9294++) {
    var effectData9294 = effectList9294[effectIndex9294];
    output.append('<p class="padb20">', soy.$$escapeHtml(effectData9294), '</p>');
  }
  output.append('<p class="el8Bold padb5">Mechanism</p>');
  var mechanismList9300 = opt_data.monograph.mechanism;
  var mechanismListLen9300 = mechanismList9300.length;
  for (var mechanismIndex9300 = 0; mechanismIndex9300 < mechanismListLen9300; mechanismIndex9300++) {
    var mechanismData9300 = mechanismList9300[mechanismIndex9300];
    output.append('<p class="padb20">', soy.$$escapeHtml(mechanismData9300), '</p>');
  }
  output.append('<p class="el8Bold padb5">Management</p>');
  var managementList9306 = opt_data.monograph.management;
  var managementListLen9306 = managementList9306.length;
  for (var managementIndex9306 = 0; managementIndex9306 < managementListLen9306; managementIndex9306++) {
    var managementData9306 = managementList9306[managementIndex9306];
    output.append('<p class="padb20">', soy.$$escapeHtml(managementData9306), '</p>');
  }
  output.append('<p class="el8Bold padb5">Discussion</p>');
  var discussionList9312 = opt_data.monograph.discussion;
  var discussionListLen9312 = discussionList9312.length;
  for (var discussionIndex9312 = 0; discussionIndex9312 < discussionListLen9312; discussionIndex9312++) {
    var discussionData9312 = discussionList9312[discussionIndex9312];
    output.append('<p class="padb20">', soy.$$escapeHtml(discussionData9312), '</p>');
  }
  output.append('<p class="el8Bold padb5">Disclaimer</p>');
  var disclaimerList9318 = opt_data.monograph.disclaimer;
  var disclaimerListLen9318 = disclaimerList9318.length;
  for (var disclaimerIndex9318 = 0; disclaimerIndex9318 < disclaimerListLen9318; disclaimerIndex9318++) {
    var disclaimerData9318 = disclaimerList9318[disclaimerIndex9318];
    output.append('<p class="padb20">', soy.$$escapeHtml(disclaimerData9318), '</p>');
  }
  output.append('<p class="el8Bold padb5">Copyright</p>');
  var copyrightList9324 = opt_data.monograph.copyright;
  var copyrightListLen9324 = copyrightList9324.length;
  for (var copyrightIndex9324 = 0; copyrightIndex9324 < copyrightListLen9324; copyrightIndex9324++) {
    var copyrightData9324 = copyrightList9324[copyrightIndex9324];
    output.append('<p class="padb20">', soy.$$escapeHtml(copyrightData9324), '</p>');
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.drugIntxns.drugDrugUnknownDetail = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer">');
  if (opt_data.unknown_medications.length) {
    output.append('<h3 class="el8NotificationAlertHeader">Unable To Provide Full Decision Support</h3><p class="padv10">We were able to check for drug-drug interactions for all medications in the patient chart except for the following user created medication', (opt_data.unknown_medications.length > 1) ? 's' : '', ':</p><ul class="el8StandardList">');
    var mList9339 = opt_data.unknown_medications;
    var mListLen9339 = mList9339.length;
    for (var mIndex9339 = 0; mIndex9339 < mListLen9339; mIndex9339++) {
      var mData9339 = mList9339[mIndex9339];
      output.append('<li class="padb5">', soy.$$escapeHtml(mData9339.id), '</li>');
    }
    output.append('</ul><p class="padb50">Please check for drug-to-drug interactions. To avoid this alert in the future, do not select the user-created medications.</p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.drugIntxns.drugAllergyResultSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.count_total > 0) {
    if (opt_data.interactions.length > 0) {
      output.append('<div class="drug-allergy-interactions el8NotificationStop alertWrap"><h3 class="el8NotificationStopHeader">!! Medication Allergy !!</h3><p><span class="alert-text">', soy.$$escapeHtml(opt_data.selected_medication_name), ' is contra-indicated for patient with allergies to ');
      var intxList9354 = opt_data.interactions;
      var intxListLen9354 = intxList9354.length;
      for (var intxIndex9354 = 0; intxIndex9354 < intxListLen9354; intxIndex9354++) {
        var intxData9354 = intxList9354[intxIndex9354];
        var allergyList9355 = intxData9354.allergies;
        var allergyListLen9355 = allergyList9355.length;
        for (var allergyIndex9355 = 0; allergyIndex9355 < allergyListLen9355; allergyIndex9355++) {
          var allergyData9355 = allergyList9355[allergyIndex9355];
          output.append(soy.$$escapeHtml(allergyData9355), (allergyIndex9355 == allergyListLen9355 - 1) ? '. ' : ', ');
        }
      }
      output.append('</span> <a class="drug-allergy-interaction-detail">view details</a></p></div>');
    }
  }
  output.append((opt_data.unknown_medications.length || opt_data.unknown_allergies.length) ? '<div class="el8NotificationAlert alertWrap"><p><span class="el8Bold el8LargeFontSize">Allergy Warnings incomplete</span> because of user created allergies. Please change to Elation Health database allergies. <a class="drug-allergy-unknown-detail">View user created allergies involved</a></p></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.drugIntxns.drugAllergyIntxnDetail = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><div class="el8NotificationStop"><h3 class="el8NotificationStopHeader">Medication Allergy</h3></div><p class="el8LargeFontSize el8Bold padb10">', soy.$$escapeHtml(opt_data.selected_medication_name), ' is contra-indicated for patient with allergies to ');
  var intxList9372 = opt_data.interactions;
  var intxListLen9372 = intxList9372.length;
  for (var intxIndex9372 = 0; intxIndex9372 < intxListLen9372; intxIndex9372++) {
    var intxData9372 = intxList9372[intxIndex9372];
    var allergyList9373 = intxData9372.allergies;
    var allergyListLen9373 = allergyList9373.length;
    for (var allergyIndex9373 = 0; allergyIndex9373 < allergyListLen9373; allergyIndex9373++) {
      var allergyData9373 = allergyList9373[allergyIndex9373];
      output.append(soy.$$escapeHtml(allergyData9373), (allergyIndex9373 == allergyListLen9373 - 1) ? '. ' : ', ');
    }
  }
  output.append('</p>');
  var intxList9383 = opt_data.interactions;
  var intxListLen9383 = intxList9383.length;
  for (var intxIndex9383 = 0; intxIndex9383 < intxListLen9383; intxIndex9383++) {
    var intxData9383 = intxList9383[intxIndex9383];
    output.append('<p class="padv10">', soy.$$escapeHtml(intxData9383.message), '</p>');
  }
  output.append('<div class="padb50"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.drugIntxns.drugAllergyUnknownDetail = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer">');
  if (opt_data.unknown_medications.length || opt_data.unknown_allergies.length) {
    output.append('<h3 class="el8NotificationAlertHeader">Unable To Provide Full Decision Support</h3><p class="padv10">We were able to check for drug-to-allergy interactions for all medications and allergies in the patient chart except for the following user created allerg', (opt_data.unknown_allergies.length > 1) ? 'ies' : 'y', ':</p><ul class="el8StandardList">');
    var mList9400 = opt_data.unknown_allergies;
    var mListLen9400 = mList9400.length;
    for (var mIndex9400 = 0; mIndex9400 < mListLen9400; mIndex9400++) {
      var mData9400 = mList9400[mIndex9400];
      output.append('<li class="padb5">', soy.$$escapeHtml(mData9400.id), '</li>');
    }
    output.append('</ul><p class="padb50">Please check for drug-to-allergy interactions. To avoid this alert in the future, do not select the user-created allergies.</p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
